/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU16Decoder,
  getU16Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type FeeRoute = {
  assetBuybackBps: number;
  numeraireBuybackBps: number;
  beneficiaryBps: number;
  lpBps: number;
};

export type FeeRouteArgs = FeeRoute;

export function getFeeRouteEncoder(): FixedSizeEncoder<FeeRouteArgs> {
  return getStructEncoder([
    ['assetBuybackBps', getU16Encoder()],
    ['numeraireBuybackBps', getU16Encoder()],
    ['beneficiaryBps', getU16Encoder()],
    ['lpBps', getU16Encoder()],
  ]);
}

export function getFeeRouteDecoder(): FixedSizeDecoder<FeeRoute> {
  return getStructDecoder([
    ['assetBuybackBps', getU16Decoder()],
    ['numeraireBuybackBps', getU16Decoder()],
    ['beneficiaryBps', getU16Decoder()],
    ['lpBps', getU16Decoder()],
  ]);
}

export function getFeeRouteCodec(): FixedSizeCodec<FeeRouteArgs, FeeRoute> {
  return combineCodec(getFeeRouteEncoder(), getFeeRouteDecoder());
}
